import Vue from 'vue'
import VueRouter from 'vue-router'
import newIndex from '../views/newIndex.vue'
import { menuArr, routerList } from './config'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'newIndex',
    component: newIndex,
    meta: {
      title: '', keywords: '智面玄赏, AI面试平台, AI招聘平台, AI简历优化, AI模拟面试, AI简历筛选、悬赏招聘, 悬赏求职, 招聘降本增效, AI分润式招聘平台',
      description: '智面玄赏是一家基于AI的分润式招聘平台，首创分润式招聘模式，通过AI简历筛选+AI面试系统帮助企业提高招聘效率，实现降本增效；同时为求职者提供AI简历优化与模拟面试服务，提升入职成功率。创新“悬赏招聘”机制，实现招聘按结果付费、零风险高效招人。'
    }
  },
  { path: '/login', name: 'Login', component: () => import('../views/login/Login.vue') },//登录
  { path: '/login_wx', name: 'Login_wx', component: () => import('../views/login/Login_wx.vue') },//微信登录
  { path: '/login_phone', name: 'Login_phone', component: () => import('../views/login/Login_phone.vue') },//手机登录
  { path: '/template', name: 'Template', component: () => import('../views/template/Template.vue') },//简历模板
  { path: '/template/:id', name: 'Tempdeil', component: () => import('../views/template/Temdeil.vue') },//简历模板详情
  { path: '/diag', name: 'Diag', component: () => import('../views/diag/Diag.vue') },//简历诊断
  { path: '/personal', name: 'Personal', component: () => import('../views/personal/Personal.vue'), },//个人中心/基本信息
  { path: '/headimg', name: 'Headimg', component: () => import('../views/personal/Headimg.vue') },//个人中心/设置头像
  { path: '/phone', name: 'Phone', component: () => import('../views/personal/Phone.vue') },//个人中心/手机绑定
  { path: '/pwd', name: 'Pwd', component: () => import('../views/personal/Pwd.vue') },//个人中心/修改密码
  { path: '/order', name: 'Order', component: () => import('../views/personal/Order.vue') },//个人中心/我的订单
  { path: '/orderdeil/:id', name: 'Orderdeil', component: () => import('../views/personal/Orderdeil.vue') },//个人中心/订单详情
  { path: '/resume', name: 'Resume', component: () => import('../views/personal/Resume.vue') },//个人中心/简历诊断
  { path: '/myresume', name: 'Myresume', component: () => import('../views/personal/Myresume.vue') },//个人中心/简历诊断
  { path: '/register', name: 'register', component: () => import('../views/register/index.vue') },//个人中心/注册
  { path: '/forget', name: 'forget', component: () => import('../views/login/forget.vue') },//忘记密码
  { path: '/eventregistration/:sourceId', name: 'eventregistration', component: () => import('../views/eventregistration/index.vue') },//活动报名
  { path: '/eventregistrationSuccess', name: 'success', component: () => import('../views/eventregistration/success.vue') },//活动报名成功
  { path: '/questionnaireSurvey', name: 'eventregistration', component: () => import('../views/questionnaireSurvey/index.vue') },//问卷调查
  { path: '/questionnaireSurveySuccess', name: 'success', component: () => import('../views/questionnaireSurvey/success.vue') },//问卷调查成功
  { path: '/lot', name: 'lot', component: () => import('../views/lot/index.vue') },//活动转盘
  {
    path: '/post', meta: {
      title: '智面玄赏 - 悬赏招聘 | AI面试平台 | AI分润式招聘平台',
      keywords: '智面玄赏, AI面试平台, AI招聘平台, AI简历优化, AI模拟面试, AI简历筛选、悬赏招聘, 悬赏求职, 招聘降本增效, AI分润式招聘平台',
      description: '智面玄赏是一家基于AI的分润式招聘平台，首创分润式招聘模式，通过AI简历筛选+AI面试系统帮助企业提高招聘效率，实现降本增效；同时为求职者提供AI简历优化与模拟面试服务，提升入职成功率。创新“悬赏招聘”机制，实现招聘按结果付费、零风险高效招人。'
    }, name: 'post', component: () => import('../views/news/news copy.vue')
  },//新闻
  {
    path: '/new', meta: {
      title: '智面玄赏 - 悬赏招聘 | AI面试平台 | AI分润式招聘平台',
      keywords: '智面玄赏, AI面试平台, AI招聘平台, AI简历优化, AI模拟面试, AI简历筛选、悬赏招聘, 悬赏求职, 招聘降本增效, AI分润式招聘平台',
      description: '智面玄赏是一家基于AI的分润式招聘平台，首创分润式招聘模式，通过AI简历筛选+AI面试系统帮助企业提高招聘效率，实现降本增效；同时为求职者提供AI简历优化与模拟面试服务，提升入职成功率。创新“悬赏招聘”机制，实现招聘按结果付费、零风险高效招人。'
    }, name: 'new', component: () => import('../views/news/news.vue')
  },//新闻/
  // {
  //   path: '/news/:id.html', meta: {
  //     title: '智面玄赏 - 悬赏招聘 | AI面试平台 | AI分润式招聘平台',
  //     keywords: '智面玄赏, AI面试平台, AI招聘平台, AI简历优化, AI模拟面试, AI简历筛选、悬赏招聘, 悬赏求职, 招聘降本增效, AI分润式招聘平台',
  //     description: '智面玄赏是一家基于AI的分润式招聘平台，首创分润式招聘模式，通过AI简历筛选+AI面试系统帮助企业提高招聘效率，实现降本增效；同时为求职者提供AI简历优化与模拟面试服务，提升入职成功率。创新“悬赏招聘”机制，实现招聘按结果付费、零风险高效招人。'
  //   }, name: 'news', component: () => import('../views/news/newsdeil.vue')
  // },//新闻/新闻详情
  {
    path: '/list2.html', meta: {
      title: '智面玄赏 - 悬赏招聘 | AI面试平台 | AI分润式招聘平台',
      keywords: '智面玄赏, AI面试平台, AI招聘平台, AI简历优化, AI模拟面试, AI简历筛选、悬赏招聘, 悬赏求职, 招聘降本增效, AI分润式招聘平台',
      description: '智面玄赏是一家基于AI的分润式招聘平台，首创分润式招聘模式，通过AI简历筛选+AI面试系统帮助企业提高招聘效率，实现降本增效；同时为求职者提供AI简历优化与模拟面试服务，提升入职成功率。创新“悬赏招聘”机制，实现招聘按结果付费、零风险高效招人。'
    }, name: 'list2', component: () => import('../views/news/list1/index.vue')
  },//新闻/面试辅导
  {
    path: '/list3.html', meta: {
      title: '智面玄赏 - 悬赏招聘 | AI面试平台 | AI分润式招聘平台',
      keywords: '智面玄赏, AI面试平台, AI招聘平台, AI简历优化, AI模拟面试, AI简历筛选、悬赏招聘, 悬赏求职, 招聘降本增效, AI分润式招聘平台',
      description: '智面玄赏是一家基于AI的分润式招聘平台，首创分润式招聘模式，通过AI简历筛选+AI面试系统帮助企业提高招聘效率，实现降本增效；同时为求职者提供AI简历优化与模拟面试服务，提升入职成功率。创新“悬赏招聘”机制，实现招聘按结果付费、零风险高效招人。'
    }, name: 'list3', component: () => import('../views/news/list2/index.vue')
  },//新闻/简历优化
  {
    path: '/list4.html', meta: {
      title: '智面玄赏 - 悬赏招聘 | AI面试平台 | AI分润式招聘平台',
      keywords: '智面玄赏, AI面试平台, AI招聘平台, AI简历优化, AI模拟面试, AI简历筛选、悬赏招聘, 悬赏求职, 招聘降本增效, AI分润式招聘平台',
      description: '智面玄赏是一家基于AI的分润式招聘平台，首创分润式招聘模式，通过AI简历筛选+AI面试系统帮助企业提高招聘效率，实现降本增效；同时为求职者提供AI简历优化与模拟面试服务，提升入职成功率。创新“悬赏招聘”机制，实现招聘按结果付费、零风险高效招人。'
    }, name: 'list4', component: () => import('../views/news/list3/index.vue')
  },//新闻/工作推荐
  {
    path: '/postdeil/:id.html', meta: {
      title: '智面玄赏 - 悬赏招聘 | AI面试平台 | AI分润式招聘平台',
      keywords: '智面玄赏, AI面试平台, AI招聘平台, AI简历优化, AI模拟面试, AI简历筛选、悬赏招聘, 悬赏求职, 招聘降本增效, AI分润式招聘平台',
      description: '智面玄赏是一家基于AI的分润式招聘平台，首创分润式招聘模式，通过AI简历筛选+AI面试系统帮助企业提高招聘效率，实现降本增效；同时为求职者提供AI简历优化与模拟面试服务，提升入职成功率。创新“悬赏招聘”机制，实现招聘按结果付费、零风险高效招人。'
    }, name: 'postdeil', component: () => import('../views/news/list4/index.vue')
  },//新闻/全部文章
  {
    path: '/n',
    meta: {
      title: '智面玄赏 - 悬赏招聘 | AI面试平台 | AI分润式招聘平台',
      keywords: '智面玄赏, AI面试平台, AI招聘平台, AI简历优化, AI模拟面试, AI简历筛选、悬赏招聘, 悬赏求职, 招聘降本增效, AI分润式招聘平台',
      description: '智面玄赏是一家基于AI的分润式招聘平台，首创分润式招聘模式，通过AI简历筛选+AI面试系统帮助企业提高招聘效率，实现降本增效；同时为求职者提供AI简历优化与模拟面试服务，提升入职成功率。创新“悬赏招聘”机制，实现招聘按结果付费、零风险高效招人。'
    }, name: 'n', component: () => import('../views/activity/newYear.vue')
  },//新年大促

  //AI面试
  {
    path: '/interview',
    meta: {
      title: '智面玄赏 - 悬赏招聘 | AI面试平台 | AI分润式招聘平台',
      keywords: '智面玄赏, AI面试平台, AI招聘平台, AI简历优化, AI模拟面试, AI简历筛选、悬赏招聘, 悬赏求职, 招聘降本增效, AI分润式招聘平台',
      description: '智面玄赏是一家基于AI的分润式招聘平台，首创分润式招聘模式，通过AI简历筛选+AI面试系统帮助企业提高招聘效率，实现降本增效；同时为求职者提供AI简历优化与模拟面试服务，提升入职成功率。创新“悬赏招聘”机制，实现招聘按结果付费、零风险高效招人。'
    },
    name: 'interview', component: () => import('../views/allTabs/interview/index.vue')
  },
  {
    path: '/bountyRecruitment',
    meta: {
      title: '智面玄赏 - 悬赏招聘 | AI面试平台 | AI分润式招聘平台',
      keywords: '智面玄赏, AI面试平台, AI招聘平台, AI简历优化, AI模拟面试, AI简历筛选、悬赏招聘, 悬赏求职, 招聘降本增效, AI分润式招聘平台',
      description: '智面玄赏是一家基于AI的分润式招聘平台，首创分润式招聘模式，通过AI简历筛选+AI面试系统帮助企业提高招聘效率，实现降本增效；同时为求职者提供AI简历优化与模拟面试服务，提升入职成功率。创新“悬赏招聘”机制，实现招聘按结果付费、零风险高效招人。'
    },
    name: 'bountyRecruitment', component: () => import('../views/allTabs/bountyRecruitment/index.vue')
  },
  {
    path: '/cooperation',
    meta: {
      title: '智面玄赏 - 悬赏招聘 | AI面试平台 | AI分润式招聘平台',
      keywords: '智面玄赏, AI面试平台, AI招聘平台, AI简历优化, AI模拟面试, AI简历筛选、悬赏招聘, 悬赏求职, 招聘降本增效, AI分润式招聘平台',
      description: '智面玄赏是一家基于AI的分润式招聘平台，首创分润式招聘模式，通过AI简历筛选+AI面试系统帮助企业提高招聘效率，实现降本增效；同时为求职者提供AI简历优化与模拟面试服务，提升入职成功率。创新“悬赏招聘”机制，实现招聘按结果付费、零风险高效招人。'
    },
    name: 'cooperation', component: () => import('../views/allTabs/cooperation/index.vue')
  },
  // 人才管理页面
  {
    path: '/talent-management',
    meta: {
      title: '智面玄赏 - 悬赏招聘 | AI面试平台 | AI分润式招聘平台',
      keywords: '智面玄赏, AI面试平台, AI招聘平台, AI简历优化, AI模拟面试, AI简历筛选、悬赏招聘, 悬赏求职, 招聘降本增效, AI分润式招聘平台',
      description: '智面玄赏是一家基于AI的分润式招聘平台，首创分润式招聘模式，通过AI简历筛选+AI面试系统帮助企业提高招聘效率，实现降本增效；同时为求职者提供AI简历优化与模拟面试服务，提升入职成功率。创新“悬赏招聘”机制，实现招聘按结果付费、零风险高效招人。'
    },
    name: 'talent', component: () => import('../views/allTabs/talent-management/index.vue')
  },
  // 就业舱
  {
    path: '/employment',
    meta: {
      title: '智面玄赏 - 悬赏招聘 | AI面试平台 | AI分润式招聘平台',
      keywords: '智面玄赏, AI面试平台, AI招聘平台, AI简历优化, AI模拟面试, AI简历筛选、悬赏招聘, 悬赏求职, 招聘降本增效, AI分润式招聘平台',
      description: '智面玄赏是一家基于AI的分润式招聘平台，首创分润式招聘模式，通过AI简历筛选+AI面试系统帮助企业提高招聘效率，实现降本增效；同时为求职者提供AI简历优化与模拟面试服务，提升入职成功率。创新“悬赏招聘”机制，实现招聘按结果付费、零风险高效招人。'
    },
    name: 'employment', component: () => import('../views/allTabs/employment/index.vue')
  },
  // 产品中心
  //案列展示
  {
    path: '/example',
    meta: {
      title: '智面玄赏 - 悬赏招聘 | AI面试平台 | AI分润式招聘平台',
      keywords: '智面玄赏, AI面试平台, AI招聘平台, AI简历优化, AI模拟面试, AI简历筛选、悬赏招聘, 悬赏求职, 招聘降本增效, AI分润式招聘平台',
      description: '智面玄赏是一家基于AI的分润式招聘平台，首创分润式招聘模式，通过AI简历筛选+AI面试系统帮助企业提高招聘效率，实现降本增效；同时为求职者提供AI简历优化与模拟面试服务，提升入职成功率。创新“悬赏招聘”机制，实现招聘按结果付费、零风险高效招人。'
    },
    name: 'example', component: () => import('../views/allTabs/example/index.vue')
  },
  {
    path: '/news',
    meta: {
      title: '智面玄赏 - 悬赏招聘 | AI面试平台 | AI分润式招聘平台',
      keywords: '智面玄赏, AI面试平台, AI招聘平台, AI简历优化, AI模拟面试, AI简历筛选、悬赏招聘, 悬赏求职, 招聘降本增效, AI分润式招聘平台',
      description: '智面玄赏是一家基于AI的分润式招聘平台，首创分润式招聘模式，通过AI简历筛选+AI面试系统帮助企业提高招聘效率，实现降本增效；同时为求职者提供AI简历优化与模拟面试服务，提升入职成功率。创新“悬赏招聘”机制，实现招聘按结果付费、零风险高效招人。'
    },
    name: 'news', component: () => import('../views/allTabs/news/index.vue')
  },
  {
    path: '/newsdetails/:id',
    meta: {
      title: '智面玄赏 - 悬赏招聘 | AI面试平台 | AI分润式招聘平台',
      keywords: '智面玄赏, AI面试平台, AI招聘平台, AI简历优化, AI模拟面试, AI简历筛选、悬赏招聘, 悬赏求职, 招聘降本增效, AI分润式招聘平台',
      description: '智面玄赏是一家基于AI的分润式招聘平台，首创分润式招聘模式，通过AI简历筛选+AI面试系统帮助企业提高招聘效率，实现降本增效；同时为求职者提供AI简历优化与模拟面试服务，提升入职成功率。创新“悬赏招聘”机制，实现招聘按结果付费、零风险高效招人。'
    },
    name: 'newsdetails', component: () => import('../views/allTabs/news/newsdeil.vue')
  },
  //关于我们
  {
    path: '/about-us',
    meta: {
      title: '智面玄赏 - 悬赏招聘 | AI面试平台 | AI分润式招聘平台',
      keywords: '智面玄赏, AI面试平台, AI招聘平台, AI简历优化, AI模拟面试, AI简历筛选、悬赏招聘, 悬赏求职, 招聘降本增效, AI分润式招聘平台',
      description: '智面玄赏是一家基于AI的分润式招聘平台，首创分润式招聘模式，通过AI简历筛选+AI面试系统帮助企业提高招聘效率，实现降本增效；同时为求职者提供AI简历优化与模拟面试服务，提升入职成功率。创新“悬赏招聘”机制，实现招聘按结果付费、零风险高效招人。'
    },

    name: 'about-us', component: () => import('../views/allTabs/about-us/index.vue')
  },
  // 求职舱
  {
    path: '/offerBot',
    meta: {
      title: '智面玄赏 - 悬赏招聘 | AI面试平台 | AI分润式招聘平台',
      keywords: '智面玄赏, AI面试平台, AI招聘平台, AI简历优化, AI模拟面试, AI简历筛选、悬赏招聘, 悬赏求职, 招聘降本增效, AI分润式招聘平台',
      description: '智面玄赏是一家基于AI的分润式招聘平台，首创分润式招聘模式，通过AI简历筛选+AI面试系统帮助企业提高招聘效率，实现降本增效；同时为求职者提供AI简历优化与模拟面试服务，提升入职成功率。创新“悬赏招聘”机制，实现招聘按结果付费、零风险高效招人。'
    },
    name: 'offerBot', component: () => import('../views/allTabs/offerBot/index.vue')
  },
]
const isMultiSpaEntry = typeof window !== 'undefined' && /\/spa\/index\.html$/i.test(window.location.pathname)

const router = new VueRouter({
  mode: isMultiSpaEntry ? 'hash' : 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export { menuArr, routerList }

export default router
